import { useState } from "react";
import { useFormContext, useWatch } from "react-hook-form";

import SelectStateModal from "../../../../../TreatmentPage/modals/state-modal/SelectStateModal";

const StateSelect = ({ name, statesData, placeholder = "State" }) => {
  const { control, setValue } = useFormContext();
  const value = useWatch({ control, name });
  const [open, setOpen] = useState(false);

  const onPick = (state) => {
    setValue(name, state.StateAbr);
    setOpen(false);
  };

  return (
    <>
      <div
        style={{
          maxWidth: "90px",
        }}
        className="d-flex-1 p-l-0 position-relative height-25 p-r-5 custom-select-new-provider"
      >
        <div
          className="dropdown-button rounded-0 p-0 p-l-5 form-control height-25 d-flex align-items-center"
          tabIndex={0}
          role="button"
          onClick={() => setOpen(true)}
          onKeyDown={(e) => {
            if (e.key === "Enter" || e.key === " ") {
              e.preventDefault();
              setOpen(true);
            }
          }}
        >
          <span>
            {value ? (
              <span className="d-flex align-items-center">
                <svg
                  style={{
                    width: 15,
                    height: 15,
                    fill: "var(--primary-80)",
                    color: "var(--primary-80)",
                    stroke: "var(--primary-80)",
                  }}
                  className={`icon icon-state-${value}`}
                >
                  <use xlinkHref={`#icon-state-${value}`} />
                </svg>
                {value}
              </span>
            ) : (
              placeholder
            )}
          </span>
        </div>
      </div>

      {open && (
        <SelectStateModal
          show={open}
          handleClose={() => setOpen(false)}
          onChange={onPick}
          statesData={statesData}
        />
      )}
    </>
  );
};

export default StateSelect;
